import { render, staticRenderFns } from "./TransactionProfileLocationInfoRow.vue?vue&type=template&id=b2e9f820&scoped=true&"
import script from "./TransactionProfileLocationInfoRow.vue?vue&type=script&lang=js&"
export * from "./TransactionProfileLocationInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./TransactionProfileLocationInfoRow.vue?vue&type=style&index=0&id=b2e9f820&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e9f820",
  null
  
)

export default component.exports